import React from 'react';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
import useMain from '../../hooks/useMain';

function Video() {
	const { theme } = useMain();
	return (
		<div className='container-fluid pb-5 pt-0'>
			<div className='row align-items-center'>
				<div className='col-lg-4 offset-lg-1'>
					<h1 className={`fw-bold text-set3-${theme}`}>BEM Foundation</h1>

					<p>
						<span className='fw-bold'>BEM Foundation</span> was established in 2020 with
						a mission to revolutionize the blockchain industry and accelerate the global
						adoption of decentralized technologies. As a pioneering force in the
						blockchain space, the foundation brings together an elite team of seasoned
						professionals in cryptocurrency, blockchain development, and digital
						marketing, leading the way in launching impactful and innovative projects.
					</p>
					<p>
						What sets BEM Foundation apart is its unwavering commitment to core
						blockchain principles—{' '}
						<span className='fw-bold'>
							decentralization, transparency, security, and equal opportunity for all.
						</span>{' '}
						By maintaining the confidentiality of its key members’ identities, the
						foundation upholds a security-first approach inspired by the decentralized
						nature of blockchain
					</p>
					<p>
						BEM Foundation’s mission goes beyond technological development; it seeks to
						build a dynamic and inclusive blockchain ecosystem that empowers individuals
						with new job opportunities, secure investment pathways, and practical tools
						for entering the world of digital finance. By continuously analyzing market
						needs and developing strategic solutions, BEM Foundation paves a seamless
						path for people to join the blockchain revolution and actively participate
						in shaping a freer, digital future.
					</p>
					<div className='pb-4'>
						<Link
							to='/about'
							className={`btn btn-set5-${theme}`}>
							Read More
						</Link>
					</div>
				</div>
				<div className='col-lg-4 offset-lg-2'>
					<ReactPlayer
						url='video/office.mp4'
						width='100%'
						controls={true}
						light='video/tumbnail.jpg'
					/>
				</div>
			</div>
		</div>
	);
}

export default Video;
